import { StaticImage } from "gatsby-plugin-image";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Agile(props) {
  return (
    <div className="tekrevol_gray_bg p-100">
      <Container classNanme="h-100">
        <Row classNanme="h-100">
          <Col xs={12} md={6} lg={6} xl={5} xxl={5}>
            <div className="example" data-text="Benefits">
              <h2>Benefits of Our Infrastructure Migration Services</h2>
            </div>
            <p>
              Migrating infrastructure to the cloud puts your web, mail, and
              application servers on a public or dedicated cloud that serves you
              with improved functionality and business performance.
              Incorporating migration service tools like EC2 AWS and dedicated
              EC2 AWS ultimately speeds up how your business works to pace up
              the service availability to your customers and users.
            </p>
            <p>
              Moreover, having a virtually available network rather than a
              physical one improves the accessibility and range of your business
              for third-party users. Migrating your network to VPC AWS, network
              ACL, and VPC peering AWS improves how well you perform on your
              clients' systems. What makes cloud infrastructure the most
              reliable service is that it provides easy, convenient, and
              streamlined access to virtually stored data in no time. Whether it
              is dealing with block storage or object storage, the use of AWS
              technologies like EBS, S3, S3 Glacier, and EFS fuels your data
              storage and access significantly.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="agile_title my-auto offset-xl-1"
          >
            <div className="content_pointer">
              <div className="pointers_item">
                <div className="title_count">
                  56+<span>Projects Completed</span>
                </div>
              </div>
              <div className="pointers_item">
                <div className="title_count">
                  23+<span>Businesses Served</span>
                </div>
              </div>
              <div className="pointers_item">
                <div className="title_count">
                  08+<span>Industries Served</span>
                </div>
              </div>
            </div>
            <StaticImage
              src="../../images/services/infrastructure/benefits.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={775}
              height={650}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Agile;
